module.exports = __webpack_public_path__ + "img/Cargando.afb65a17.png";